import { render, staticRenderFns } from "./CurriculumPage.vue?vue&type=template&id=7063bd32&scoped=true"
import script from "./CurriculumPage.vue?vue&type=script&lang=js"
export * from "./CurriculumPage.vue?vue&type=script&lang=js"
import style0 from "./CurriculumPage.vue?vue&type=style&index=0&id=7063bd32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063bd32",
  null
  
)

export default component.exports